var amdi18n={"__root":{"dev_groups_can_create_text1":"Create a Development Device Group and assign development devices to begin testing your product.","factory_workspace_settings_title":"Test Fixture Device Group Settings","pre_production_devicegroup_settings_title":"Test Production Device Group Settings","production_devicegroup_settings_title":"Production Device Group Settings","production_devicegroup_create_title":"Create a Production Device Group","pre_production_devicegroup_create_title":"Create a Test Production Device Group","production_device_group_settings_modal_subtitle":"When should blessed devices receive code from their assigned device group?","immediately_deploy_after_blessing":"Devices download deployed application immediately after blessing","deploy_after_blinkup":"Devices download deployed application after first end-user BlinkUp™","webhook":"Webhooks","event":"Event","content_type":"Content Type","blessing":"Blessing","blinkup":"BlinkUp","update_settings":"Update","create":"Create","tooltip_1":"You can use these webhooks to notify your own record-keeping system of device events: ","tooltip_2":" webhook is triggered automatically when a device has been successfully blessed.","tooltip_3":" webhook is triggered automatically when an end-user device successfully configures a device using BlinkUp™."}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;